import React from 'react';
import { ToastContext, Dropdown } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../context/useAppContext';
import EventsPickerModal from '../../../../components/rates/eventsPickerModal';
import RateTemplate from '../../../../models/rateTemplate';
import PropTypes from 'prop-types';

export function LinkEventAction({ objects: selectedRates, events, reloadList }) {
    const [showModal, setShowModal] = React.useState(false);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();

    const formatLabel = React.useCallback((event, t) => {
        return (
            event.name +
            ' - ' +
            new Date(event.start_date).toLocaleDateString([], { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: event.timezone }) +
            ' - ' +
            event.id +
            ' - ' +
            t('ticket.rate_template.' + event.publication_status)
        );
    }, []);

    const linkEvents = React.useCallback(
        selected => {
            setIsSubmitting(true);
            let selectedEvents = selected.map(event => event.id);
            const ratesToSave = [];
            selectedRates.forEach(rate => {
                let linkedEvents = rate.events.map(event => event.id);
                let newSelected = selectedEvents.filter(event_id => !linkedEvents.includes(event_id)).map(event_id => event_id);
                let rateTmp = {
                    uuid: rate.pk,
                    event_ids: newSelected
                };
                if (newSelected.length) {
                    ratesToSave.push(new RateTemplate(rateTmp));
                } else {
                    toast.info(t(`ticket.rates.linkEventsAlreadyLinked`, { name: rate.name }));
                }
            });
            RateTemplate.save(ratesToSave, { organizationId: organization.pk })
                .then(({ status, headers, response }) => {
                    if (status === 206) {
                        return toast.error(t(`ticket.rates.linkEventsPartialError`, { events: response.error.map(({ event: e }) => `${e.name} (${e.id})`).join(', ') }));
                    }
                    toast.success(t(`ticket.rates.linkEventsSuccess`, { count: ratesToSave.length }));
                })
                .catch(e => {
                    console.error(e);
                    toast.error(t(`ticket.rates.linkEventsError`, { count: ratesToSave.length }));
                })
                .finally(() => {
                    setIsSubmitting(false);
                    setShowModal(false);
                    reloadList();
                });
        },
        [selectedRates, organization, events, reloadList]
    );

    return (
        <React.Fragment>
            {showModal && (
                <EventsPickerModal events={events} open={showModal} close={() => setShowModal(false)} formatLabel={formatLabel} onSubmit={linkEvents} isSubmitting={isSubmitting} />
            )}
            <Dropdown.Item onClick={() => setShowModal(true)}>{t('ticket.rates.linkEvents')}</Dropdown.Item>
        </React.Fragment>
    );
}

LinkEventAction.propTypes = {
    objects: PropTypes.array.isRequired,
    events: PropTypes.array.isRequired,
    onSave: PropTypes.func
};
